"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReferenceContentNode = exports.ReferenceContentFields = void 0;
exports.isValidReferenceContentField = isValidReferenceContentField;
exports.makeReferenceContent = makeReferenceContent;
const utils_1 = require("../utils");
const ast_classes_1 = require("../ast-classes");
exports.ReferenceContentFields = ['href', 'format', 'scope'];
function isValidReferenceContentField(field, value) {
    switch (field) {
        case 'href': return (0, utils_1.isOrUndefined)(ast_classes_1.isCDATA, value);
        case 'format': return (0, utils_1.isOrUndefined)(ast_classes_1.isCDATA, value);
        case 'scope': return (0, utils_1.isOrUndefined)(ast_classes_1.isReferenceContentScope, value);
        default: return false;
    }
}
const isReferenceContentNode = (value) => typeof value === 'object' && !!value && (0, utils_1.areFieldsValid)(exports.ReferenceContentFields, value, isValidReferenceContentField);
exports.isReferenceContentNode = isReferenceContentNode;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function makeReferenceContent(constructor) {
    return class extends constructor {
        get 'href'() {
            return this.readProp('href');
        }
        set 'href'(value) {
            this.writeProp('href', value);
        }
        get 'format'() {
            return this.readProp('format');
        }
        set 'format'(value) {
            this.writeProp('format', value);
        }
        get 'scope'() {
            return this.readProp('scope');
        }
        set 'scope'(value) {
            this.writeProp('scope', value);
        }
    };
}
//# sourceMappingURL=reference-content.js.map